<div class="all-content">
    <div class="row">
        <div class="item">
            <span> {{ getLanguages('businessSolution/modal/phase/nameOportunity') }} </span>
            <input disabled type="text" [(ngModel)]="parameters.item.label" class="input-disabled">
        </div>
        <div class="item td-date">
            <span> {{ getLanguages('businessSolution/modal/phase/entryDate') }} </span>
            <div class="input-disabled">
                <input matInput [(ngModel)]="parameters.item.phase.entryDate" disabled
                [matDatepicker]="picker" (keypress)="allowNumbersOnly($event)"
                (input)="onDateInputChange($event)">
                <mat-datepicker #picker></mat-datepicker>
                <button disabled class="disabled-icon">
                    <!-- <i class="fas fa-calendar-days"></i> -->
                </button>            </div>
        </div>
        <div class="item">
            <span> {{ getLanguages('businessSolution/modal/phase/weeks') }} </span>
            <input disabled type="text" [ngModel]="parameters.item.phase.weeks_quantity" class="input-disabled">
        </div>
    </div>
    <div class="row">
        <div class="item td-date" style="width: calc(100% / 3);">
            <span> {{ getLanguages('businessSolution/modal/fte/start_date') }} </span>
            <div (click)="focusInput($event)" [ngClass]="!parameters.isEdit ? 'input-disabled' : 'div'">
                <input matInput [(ngModel)]="parameters.item.fte_tab.start_date" [disabled]="!parameters.isEdit"
                    [matDatepicker]="picker1" (keypress)="validateDateInput($event)"
                    (input)="onDateInputChange($event)" (blur)="onDateBlur($event)" [min]="minDate">
                <mat-datepicker #picker1></mat-datepicker>
                <button [disabled]="!parameters.isEdit" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'"
                    (click)="picker1.open()">
                    <i class="fas fa-calendar-days"></i>
                </button>
            </div>
        </div>
        <div class="item td-date" style="width: calc(100% / 3);">
            <span> {{ getLanguages('businessSolution/modal/fte/end_date') }} </span>
            <div (click)="focusInput($event)" [ngClass]="!parameters.isEdit ? 'input-disabled' : 'div'">
                <input matInput [(ngModel)]="parameters.item.fte_tab.end_date" [disabled]="!parameters.isEdit"
                    [matDatepicker]="picker2" (keypress)="validateDateInput($event)"
                    (input)="onDateInputChange($event)" [min]="minDate" (blur)="onDateBlur($event)">
                <mat-datepicker #picker2></mat-datepicker>
                <button [disabled]="!parameters.isEdit" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'"
                    (click)="picker2.open()">
                    <i class="fas fa-calendar-days"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="item" style="width: calc(100% / 3);">
            <span>{{ getLanguages('businessSolution/modal/fte/arbitrary_value') }}</span>
            <input
              type="text"
              [(ngModel)]="parameters.item.fte_tab.arbitrary_value"
              [ngClass]="!parameters.isEdit ? 'input-disabled' : ''"
              placeholder="0,00"
              (keypress)="validateInput($event)"
              (blur)="formatCurrency(parameters.item.fte_tab, 'arbitrary_value')"
            />
        </div>
          
        <div class="item" style="width: calc(100% / 3);">
            <span>{{ getLanguages('businessSolution/modal/fte/real_value') }}</span>
            <input
              type="text"
              [(ngModel)]="parameters.item.fte_tab.real_value"
              [ngClass]="!parameters.isEdit ? 'input-disabled' : ''"
              placeholder="0,00"
              (keypress)="validateInput($event)"
              (blur)="formatCurrency(parameters.item.fte_tab, 'real_value')"
            />
        </div>
          
        
        <div class="item" style="width: calc(100% / 3);">
            <span> {{ getLanguages('businessSolution/modal/fte/isSap') }} </span>
            <button class="button-menu" [disabled]="!parameters.isEdit" [ngClass]="!parameters.isEdit ? 'disabled' : ''" [matMenuTriggerFor]="isSap">
                <span>
                  {{ this.parameters.item.fte_tab.isSap == 'yes' ? getLanguages('businessSolution/modal/fte/yes') : getLanguages('businessSolution/modal/fte/no') }}
                </span>
                <i class="fa-solid fa-caret-down" *ngIf="parameters.isEdit"></i>
              </button>
        
              <mat-menu #isSap="matMenu">
                <div class="menu">
                  <div class="scroll">
                    <ng-container *ngFor="let item of arrayIsSap">
                        <div class="item-menu" (click)="choseItemSelect('isSap', item)">
                          <span [ngClass]="item?.slug == this.parameters.item.fte_tab.isSap ? 'valid-span' : 'invalid-span'">
                            {{ getName(item) }}
                          </span>
                        </div>
                    </ng-container>
                  </div>
                </div>
              </mat-menu>
        </div>
    </div>
    <div class="row row-end">
        <div class="button-upload" (click)="newMonth()" [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
            {{ getLanguages('businessSolution/modal/fte/addMonth') }}
        </div>
    </div>
    <div class="row" *ngIf="isData()">
        <p-table *ngIf="getDisplayedRows().length !== 0" [value]="getDisplayedRows()" class="table-project">
            <!-- [sortField]="'updated_date'" [sortOrder]="1"> -->
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="month" class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/fte/month') }} </span>
                    </th>
                    <th pSortableColumn="fte" class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/fte/fte') }} </span>
                    </th>
                    <th pSortableColumn="observation" class="td-35">
                        <span> {{ getLanguages('businessSolution/modal/phase/observation') }} </span>
                    </th>
                    <th class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/phase/action') }} </span>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                <tr>
                    <td class="td-15">
                        <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.month"></textarea>
                    </td>
                    <td class="td-15">
                        <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.fte" (input)="allowNumbersOnly($event)"></textarea>
                    </td>
                    <td class="td-35">
                        <textarea 
                            [disabled]="!parameters.isEdit" 
                            [(ngModel)]="row.observation"
                            (input)="adjustTextareaHeight($event)"
                        ></textarea>
                    </td>
                    <td class="td-15">
                        <div class="align-center" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'">
                            <i class="fa-solid fa-trash pointer" (click)="deleteMonth(row.uuid)"
                                [ngClass]="!parameters.isEdit ? 'disabled-icon no-pointer' : 'icon'"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="row row-start" *ngIf="isData()">
        <span class="sumFte-title">
            {{ getLanguages('businessSolution/modal/fte/sumFte') }}
        </span>
        <div class="sumFte">
            <span>  
                {{ getSumFte() }}
            </span>
        </div>
    </div>
    <div class="div-paginator" *ngIf="isData()">
        <div class="paginator">
            <span>
                {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
            </span>
            <button [matMenuTriggerFor]="menu" class="itens-per-page">
                {{ getItemsPerPage() }}
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="choseItemsPage(5)">5</button>
                <button mat-menu-item (click)="choseItemsPage(10)">10</button>
            </mat-menu>
            <span>
                {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
            </span>
            <span class="totalPages">
                {{ getTotalPages()}}
            </span>
            <button [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'"
                [disabled]="getCurrentPages() === 1" (click)="onPageChange(getCurrentPages() - 1, 'strategy')">
                <i class="fa-solid fa-angle-left"></i>
            </button>
            <input type="number" [ngModel]="getCurrentPages()" (blur)="checkValue()">
            <button [ngClass]="getCurrentPages() == getTotalPages() ? 'disabled-arrow' : 'arrow'"
                [disabled]="getCurrentPages() == getTotalPages()"
                (click)="onPageChange(getCurrentPages() + 1, 'strategy')">
                <i class="fa-solid fa-angle-right"></i>
            </button>
        </div>
    </div>

</div>